// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-prodgallerybox]", {
    zoomEffect: true,
  });

  const gallerySwipper = new Swiper(".swiper", {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 20,
        slidesPerView: 1,
      },
      991: {
        spaceBetween: 72,
        slidesPerView: "auto",
        centeredSlides: true,
      },
    },
  });
});
